// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"787":"0af4fa3d","937":"b3dd9899"}[chunkId] + ".chunk.js";
};